import React from 'react';
import { Col, Row } from '../../components/Bootstrap';
import { BigNumber } from '../../components/BigNumber';
import './Demographics.scss';
import { Genders } from './Genders';
import { TopCustomers } from './TopCustomers';

export const Demographics = ({ loading, stats }) => {
  if (loading || !stats) {
    return <div className='text-center'>Loading...</div>;
  }

  const {
    averageAge,
    genders,
    topCustomersOrders,
    topCustomersDrinks,
    reorderPercentages,
    averageSpendPerNight,
    averageReorderTime,
  } = stats;

  const avgReTime = averageReorderTime.minutes >= 0 && `${averageReorderTime.minutes}:${averageReorderTime.seconds}`;

  return (
    <div className='demographics-container'>
      <Row>
        <Col md={6} xs={12}>
          <TopCustomers topCustomersOrders={topCustomersOrders} topCustomersDrinks={topCustomersDrinks} />
        </Col>
        <Col md={6} className='right-col'>
          <div className='h-md-33'>
            <Row className='h-100-full'>
              <Col md={6} xs={12}>
                <BigNumber
                  title='Reorder Percentage'
                  data={reorderPercentages && `${reorderPercentages}%`}
                  className='border-top-0 border-right-0 border-bottom-0 h-100-full reorder-percentage'
                />
              </Col>
              <Col md={6}>
                <BigNumber className='border-top-0 h-100-full' title='Average Reorder Time' data={avgReTime} />
              </Col>
            </Row>
          </div>
          <div className='h-md-34'>
            <Row className='h-100-full'>
              <Col>
                <Genders data={genders} />
              </Col>
            </Row>
          </div>
          <div className='h-md-33'>
            <Row className='h-100-full'>
              <Col md={6} xs={12}>
                <BigNumber title='Average Age' data={averageAge} className='border-top-0 h-100-full' />
              </Col>
              <Col md={6}>
                <BigNumber
                  title='Average Nightly Spend'
                  data={averageSpendPerNight >= 0 && `$${averageSpendPerNight}`}
                  className='border-0 h-100-full'
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};
